module.exports = __webpack_public_path__ + "static/media/pl14.cb07bec0.svg";